import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Divider,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import TrimAndFlashing from "./TrimAndFlashing";
import FlatSheet from "./FlatSheet";
import Coil from "./Coil";
import Panel from "./Panel";
import Accessory from "./Accessory";
import BenchWork from "./BenchWork";

const Items = ({ quote, defaultVariables, onUpdateQuote }) => {
  const theme = useTheme();

  const [productMap, setProductMap] = useState(new Map());

  const getProductMap = (quote) => {
    const prodMap = new Map();
    let quoteItems = quote.items ?? [];
    for (let i = 0; i < quoteItems.length; i++) {
      let orderItem = quoteItems[i];
      prodMap.set(`${orderItem.objectType}`, orderItem);
    }
    setProductMap(prodMap);
  };

  // This is causing the lag. We need a new way to display items
  // without relying on map which updates the whole thing on every quote change
  useEffect(() => {
    if (quote && quote.items) {
      getProductMap(quote);
    } else {
      setProductMap(new Map());
    }
  }, [quote]);

  return (
    <Box>
      <Box>
        {productMap.has("FlatSheet") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <FlatSheet
              isTollForm={quote.isTollForm}
              quoteFlatSheetCost={quote.flatSheetCost}
              flatSheet={productMap.get("FlatSheet")}
              onUpdateFlatSheet={(flatSheet) => {
                console.log("onUpdateFlatSheet", flatSheet);
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "FlatSheet") {
                    quoteItemsCopy[i] = flatSheet;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
        {productMap.has("Coil") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <Coil
              isTollForm={quote.isTollForm}
              coil={productMap.get("Coil")}
              onUpdateCoil={(coil) => {
                console.log("onUpdateCoil", coil);
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "Coil") {
                    quoteItemsCopy[i] = coil;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
        {productMap.has("Panel") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <Panel
              isTollForm={quote.isTollForm}
              coilCostPerSqFt={quote.coilCostPerSqFt}
              panel={productMap.get("Panel")}
              onUpdatePanel={(panel) => {
                console.log("onUpdatePanel", panel);
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "Panel") {
                    quoteItemsCopy[i] = panel;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
        {productMap.has("TrimAndFlashing") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <TrimAndFlashing
              isTollForm={quote.isTollForm}
              flatSheetSize={quote.flatSheetSize}
              defaultVariables={defaultVariables}
              companyId={quote.company.id}
              orderItem={productMap.get("TrimAndFlashing")}
              onUpdate={(trimAndFlashing) => {
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "TrimAndFlashing") {
                    quoteItemsCopy[i] = trimAndFlashing;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
        {productMap.has("BenchWork") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <BenchWork
              isTollForm={quote.isTollForm}
              trimType="BenchWork"
              flatSheetSize={quote.flatSheetSize}
              defaultVariables={defaultVariables}
              companyId={quote.company.id}
              orderItem={productMap.get("BenchWork")}
              onUpdate={(benchWork) => {
                console.log("onUpdateBenchWork", benchWork);
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "BenchWork") {
                    quoteItemsCopy[i] = benchWork;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
        {productMap.has("CopingCap") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <TrimAndFlashing
              isTollForm={quote.isTollForm}
              trimType="CopingCap"
              flatSheetSize={quote.flatSheetSize}
              defaultVariables={defaultVariables}
              companyId={quote.company.id}
              orderItem={productMap.get("CopingCap")}
              onUpdate={(copingCap) => {
                console.log("onUpdateCopingCap", copingCap);
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "CopingCap") {
                    quoteItemsCopy[i] = copingCap;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
        {productMap.has("CopingCapCleat") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <TrimAndFlashing
              isTollForm={quote.isTollForm}
              trimType="CopingCapCleat"
              flatSheetSize={quote.flatSheetSize}
              defaultVariables={defaultVariables}
              companyId={quote.company.id}
              orderItem={productMap.get("CopingCapCleat")}
              onUpdate={(copingCapCleat) => {
                console.log("onUpdateCopingCapCleat", copingCapCleat);
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "CopingCapCleat") {
                    quoteItemsCopy[i] = copingCapCleat;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
        {productMap.has("SplicePlate") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <TrimAndFlashing
              isTollForm={quote.isTollForm}
              trimType="SplicePlate"
              flatSheetSize={quote.flatSheetSize}
              defaultVariables={defaultVariables}
              companyId={quote.company.id}
              orderItem={productMap.get("SplicePlate")}
              onUpdate={(splicePlate) => {
                console.log("onUpdateSplicePlate", splicePlate);
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "SplicePlate") {
                    quoteItemsCopy[i] = splicePlate;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
        {productMap.has("Accessory") && (
          <Box>
            <Divider sx={{ marginTop: "16px", marginBottom: "16px" }} />
            <Accessory
              defaultVariables={defaultVariables}
              accessory={productMap.get("Accessory")}
              onUpdateAccessory={(accessory) => {
                console.log("onUpdateAccessory", accessory);
                let quoteItems = quote.items ?? [];
                let quoteItemsCopy = [...quoteItems];
                for (let i = 0; i < quoteItemsCopy.length; i++) {
                  let item = quoteItemsCopy[i];
                  if (item.objectType == "Accessory") {
                    quoteItemsCopy[i] = accessory;
                  }
                }
                onUpdateQuote({ items: quoteItemsCopy });
              }}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Items;
